import { NAME } from './constants';

export const SHOW_SIDEBAR = `${NAME}/show`;
export const HIDE_SIDEBAR = `${NAME}/hide`;
export const TOGGLE_SIDEBAR = `${NAME}/toggle`;
